<template>
  <div class="pad-15 locales" :key="currentLocale">
    <dl class="dropdown">
      <input type="checkbox" :id="id" v-model="isDropDownOpen">
      <dt>
        <label :for="id" class="selected">
          <span>
            <img :src="icon(currentLocale)" :height="height" />
            {{ $t('Lang.' + currentLocale) }}
          </span>
        </label>
      </dt>
      <dd>
        <ul>
          <li v-for="(locale, index) in locales" :key="index" class="locale-line">
            <a v-on:click="changeLocale(locale)" :class="locale === currentLocale ? 'selected' : ''">
              <span>
                <img :src="icon(locale)" :height="height" />
                {{ $t('Lang.' + locale) }}
              </span>
            </a>
          </li>
        </ul>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'ShortLangPicker',
  props: {
    id: {
      type: String,
      default: 'short-locale-picker'
    },
    height: {
      type: Number,
      default: 32
    }
  },
  data() {
    return {
      isDropDownOpen: false
    }
  },
  mounted() {
    window.addEventListener('click', this.closeDropDown);
  },
  beforeUnmount() {
    window.removeEventListener('click', this.closeDropDown);
  },
  computed: {
    locales() {
      return Object.keys(this.$i18n.messages);
    },
    currentLocale() {
      return this.$i18n.locale
    },
  },
  methods: {
    closeDropDown() {
      if (this.isDropDownOpen) {
        this.isDropDownOpen = false;
      }
    },
    changeLocale(locale) {
      this.$emit('changeLocale', locale);
    },
    icon(locale) {
      return `/img/flags/${locale}.png`;
    },
  }
}
</script>

<style scoped lang="scss">
  label.selected {
    span {
      padding-right: 1.5em;
    }
  }

  .locales {
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    left: auto;
    width: auto;
    background: no-repeat;
    border: 0;
  }

  .locales .btn {
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none !important;
  }

  .locales .btn.btn-default {
    box-shadow: none;
  }

  .locales .locale-line {
    white-space: nowrap;
  }
</style>
